import {useHistory as _useHistory} from 'react-router-dom'

const useHistory = _useHistory;

export default useHistory;
